export enum StageOperationEnum {
  PUBLISH = 'PUBLISH',
  SAVE = 'SAVE',
}
